import isNil from "lodash/fp/isNil";
import map from "lodash/fp/map";

const getIds = (item) => {
  let itemId = null;

  if (!isNil(item.name && item.name._id)) {
    itemId = item.name._id;
  } else if (!isNil(item._id)) {
    itemId = item._id;
  }
  if (item.selected) {
    itemId = item.selected.name._id;
  }
  return itemId;
};

export const mapGetIds = map(getIds);
export const mapKeyValue = map((item) => item.value);
export const phoneformatter = (phone) => `2${phone}`;



// WEBPACK FOOTER //
// ./src/core/transforms.js